export default class ClientServices {
    static readonly APPOINTMENT = "Appointment"
    static readonly MANUAL = "Manual";
    static readonly MESSAGE = "Message";
    static readonly REQUEST = "Request";
}